// deps
import React from "react";
// dls comp
import { default as CloseIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/clearFilled/16";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

import { CUTLERY_WIDGET_DATA_TEST_ID } from "@swiggy-private/cart-test-ids";

// constants
import { NUDGE_CUTLERY_TEXT, TOOLTIP_CROSS_ICON_COLOR } from "./constants";

// style
import { FTUENudge } from "./styles";

interface CutleryFTUENudgeProps {
    showNudge: boolean;
    checked: boolean;
    handleShowNudge: () => void;
    nudgeRef: React.RefObject<HTMLDivElement>;
}

const CutleryFTUENudge: React.FC<CutleryFTUENudgeProps> = ({ showNudge, checked, handleShowNudge, nudgeRef }) => {
    return (
        <>
            {showNudge && !checked && (
                <FTUENudge ref={nudgeRef} data-testid={CUTLERY_WIDGET_DATA_TEST_ID.NUDGE}>
                    <Text variant="V2.body3.neutral.bold" color="text_inverse_Highest_Emphasis">
                        {NUDGE_CUTLERY_TEXT}
                    </Text>
                    <GenericIcon
                        onClick={handleShowNudge}
                        Icon={CloseIcon}
                        strokeColor="background_Primary"
                        customFillColor={{
                            light: TOOLTIP_CROSS_ICON_COLOR,
                            dark: TOOLTIP_CROSS_ICON_COLOR,
                        }}
                    />
                </FTUENudge>
            )}
        </>
    );
};

export default CutleryFTUENudge;
